import React from 'react';

import LoadingWidget from '../LoadingWidget';

const fullScreenStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
};

const AuthenticatedLoadingScreen = () => (
  <div style={fullScreenStyle} aria-label='Cargando plataforma'>
    <LoadingWidget />
  </div>
);

export default AuthenticatedLoadingScreen;
